import { render, staticRenderFns } from "./AssetBlock.vue?vue&type=template&id=2b86ceed&scoped=true&"
import script from "./AssetBlock.vue?vue&type=script&lang=js&"
export * from "./AssetBlock.vue?vue&type=script&lang=js&"
import style0 from "./AssetBlock.vue?vue&type=style&index=0&id=2b86ceed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b86ceed",
  null
  
)

export default component.exports